class AlertController {

    constructor() {

        this._title = "";
        this._content = "";
        this._icon = "";
        this._animationSpeed = 250;
        this._animationDuration = 3000;

    }

    setOptions(options) {

        this._title = options.title;
        this._content = options.content;
        this._icon = options.icon;
        this._animationSpeed = options.animationSpeed || this._animationSpeed;
        this._animationDuration = options.animationDuration || this._animationDuration;

        const $title = $(".bf-alert p.title");
        const $content = $(".bf-alert div.content");
        const $icon = $(".bf-alert img.icon");

        $title.text(this._title);
        $content.html(this._content);
        $icon.attr("src", this._icon);

    }

    show() {

        function _onAnimationComplete() {

            if (that._animationDuration > 0) {
                setTimeout(that.hide.bind(that), that._animationDuration);
            }

        }

        const $alert = $("div.bf-alert");
        const that = this;

        $alert.animate({top: 25, opacity: 1}, this._animationSpeed, _onAnimationComplete);

    }

    hide() {

        const $alert = $("div.bf-alert");
        const that = this;

        $alert.animate({top: -200, opacity: 0}, this._animationSpeed);

    }

}
